import React from 'react';
import { useUnits } from '../../context/UnitsContext';
import { UI_MESSAGES } from '../../constants/Constants';
import { isConsortiaUnitForWindow } from '../../utils/utils';
import {useModerationWindowSession} from '../../constants/Constants';


const UnitsSelector = ({ subjectData,selectedUnits = [], onChange , showErrors, selectedWindow, currentCentreType =''}) => {

  const { units = [] , consortiaUnits = []} = useUnits();
  const moderationWindows = useModerationWindowSession();

  const hasError = showErrors && !selectedUnits.length;
  const handleUnitChange = (unitId) => {
    const newSelection = selectedUnits.includes(unitId)
      ? selectedUnits.filter(id => id !== unitId)
      : [...selectedUnits, unitId];
    onChange(newSelection);
  };
  const sortedUnits = (units || []).filter(u => typeof u.assessmentCode === "string" && u.assessmentCode.length <= 4) 
  .slice().sort((a, b) => a.assessmentCode.localeCompare(b.assessmentCode));
  return (
    <div className={`field mb-5 ${hasError ? 'field-validation has-error' : ''}`}>
      <label className="label has-text-weight-semibold">
        Which units will be moderated on this visit? <span className="has-text-danger">*</span>
      </label>
      <div className="control">
        {sortedUnits.length ? sortedUnits.map(unit => (
          <label key={unit.assessmentCode} className={`checkbox is-block mb-1 ${hasError ? 'has-error' : ''}`}>
            <input
              type="checkbox"
              checked={selectedUnits.includes(unit.assessmentCode)}
              disabled={currentCentreType === 'Rest' && isConsortiaUnitForWindow(unit.assessmentCode, consortiaUnits, selectedWindow, moderationWindows)}
              onChange={() => handleUnitChange(unit.assessmentCode)}
              className="mr-2"
            />
            {unit.assessmentCode} {unit.assessmentName}
           
             {currentCentreType && isConsortiaUnitForWindow(unit.assessmentCode, consortiaUnits, selectedWindow, moderationWindows) &&  <span class="tag is-warning"> Consortia unit</span>}
          </label>
        )) : UI_MESSAGES.NO_DATA_FOUND}
      </div>
      {showErrors && !selectedUnits.length && <span className="is-validation-message"> You must select at least one unit</span>} 
    </div>
  );
};

export default UnitsSelector;